function IsValidUrl(url) {	
	try {
		new URL(url);
		return true;
	} 
	catch (error) {
		return false;
	}
}
export default IsValidUrl;